<cbc-container [isLoading]="isLoading" [showContainer]="true" title="Perfil Prestador de Serviços Pessoa Física">
</cbc-container>

@if (providerPFForm) {

<div class="container" [class.is_mobile]="isMobile">
  <!-- ========== SEÇÃO: MENU DE NAVEGAÇÃO ========== -->

  <div class="swiper-menu">
    <div class="mini-card-container">
      <div class="mini-card" [class.selected]="selectedTab.value === 'tab1'" (click)="selectedTab.setValue('tab1')">
        <img src="assets/icons/icon_conta_editar_dadospessoais.svg" alt="Dados Profissionais" width="40px">
        <span>Dados Profissionais</span>
      </div>

      <div class="mini-card" *ngIf="providerPFForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab2'"
        (click)="selectedTab.setValue('tab2')">
        <img src="assets/icons/icon_conta_editar_registros.svg" alt="Registros" width="40px">
        <span>Registros</span>
      </div>

      <div class="mini-card" *ngIf="providerPFForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab3'"
        (click)="selectedTab.setValue('tab3')">
        <img src="assets/icons/icon_conta_editar_documentos.svg" alt="Documentos" width="40px">
        <span>Documentos</span>
      </div>

      <div class="mini-card" *ngIf="providerPFForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab4'"
        (click)="selectedTab.setValue('tab4')">
        <img src="assets/icons/icon_conta_editar_enderecos.svg" alt="Endereços" width="40px">
        <span>Endereços</span>
      </div>

      <div class="mini-card" *ngIf="providerPFForm.controls['id'].value" [class.selected]="selectedTab.value === 'tab5'"
        (click)="selectedTab.setValue('tab5')">
        <img src="assets/icons/icon_conta_editar_certificados.svg" alt="Certificados" width="40px">
        <span>Certificados</span>
      </div>
    </div>
  </div>

</div>

<app-swiper swiperContainerId="why-us-swiper">
  <swiper-container #swiper class="swiper" pagination="false" autoplay="false">

    <!-- ========== SLIDE 1: DADOS PROFISSIONAIS ========== -->
    <swiper-slide>
      <div class="slideContainer">
        <div class="form-container" [class.is_mobile]="isMobile">
          <form [formGroup]="providerPFForm">

            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Código CNES</mat-label>
                <input matInput formControlName="cnesCode" type="text" mask="0*" [showMaskTyped]="false" />
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline" floatLabel="always" class="full-width">
                <mat-label>Nome</mat-label>
                <input matInput formControlName="name" />
              </mat-form-field>
            </div>

            <div class="row-2-col">
              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" [email]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline" floatLabel="always">
                <mat-label>Nr. Telefone</mat-label>
                <input matInput formControlName="phoneNumber" mask="(00) 00000-0000" [showMaskTyped]="true" />
              </mat-form-field>
            </div>
          </form>

          <div class="footerButtons">
            <button (click)="saveProfileProviderPF()" [hidden]="!isEditMode" mat-flat-button color="primary"
              [disabled]="!providerPFForm.valid" class="btn btn-primary">
              Salvar
            </button>

            <button mat-flat-button color="primary" (click)="editMode(true)" [hidden]="isEditMode"
              class="btn btn-primary">
              Editar
            </button>
          </div>
        </div>
      </div>
    </swiper-slide>

    <!-- ========== SLIDE 2: REGISTROS ========== -->
    <swiper-slide>
      <div class="slideContainer">
        <div class="container">
          @if(providerPFForm.controls['id'].value){
          <app-council [profileProviderPFId]="providerPFForm.controls['id'].value"
            [profileProviderPF]="providerPFForm.value" (hasAnyProfileCouncil)="hasAnyProfileCouncilFinder()"
            (councilChanged)="refreshCertifications()">
          </app-council>
          }
        </div>
      </div>
    </swiper-slide>

    <!-- ========== SLIDE 3: DOCUMENTOS ========== -->
    <swiper-slide>
      <div class="slideContainer">
        <div class="container">
          @if(providerPFForm && providerPFForm.controls['id'].value && providerPFForm.controls['cpf'].value){
          <app-attachment [documentTypesRequired]="documentTypesRequired"
            [ownerDocumentsCpfCnpj]="providerPFForm.controls['cpf'].value"
            (attachmentChanged)="refreshCertifications()">
          </app-attachment>
          }
        </div>
      </div>
    </swiper-slide>

    <!-- ========== SLIDE 4: ENDEREÇOS ========== -->
    <swiper-slide>
      <div class="slideContainer">
        <div class="container">
        <app-address-list [addresses]="addresses" (addAddress)="openAddressDialog()"
          (deleteAddress)="deleteAddress($event)" (editAddress)="editAddress($event)"
          (setCommercialAddress)="setCommercialAddress($event)">
        </app-address-list>
      </div>
      </div>
    </swiper-slide>

    <!-- ========== SLIDE 5: CERTIFICADOS ========== -->
    <swiper-slide>
      <div class="slideContainer">
        <div class="form-container" [class.is_mobile]="isMobile">
          <div class="card">
            @if(providerPFForm.controls["id"].value){

            <div class="card-header">
              <h3 class="card-title">Status de Certificação</h3>
            </div>

            <div class="card-body">
              <div class="info-row">
                <span class="info-label">Dados Profissionais:</span>
                <span class="info-separator"></span>
                <span class="info-data">
                  @if (checkCertifiedCompanyData()){
                  <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical"
                    width="24px" alt="Certificado concedido">
                  } @else {
                  <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                    alt="Certificado ausente">
                  }
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Registros de Conselhos e Profissões:</span>
                <span class="info-separator"></span>
                <span class="info-data">
                  @if (isCertifiedCouncilAndProfession){
                  <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical"
                    width="24px" alt="Certificado concedido">
                  } @else {
                  <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                    alt="Certificado ausente">
                  }
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Documentos:</span>
                <span class="info-separator"></span>
                <span class="info-data">
                  @if (isCertifiedDocuments){
                  <img src="assets/icons/icon_certificado_concedido.svg" matTooltip="Certificado Hub Medical"
                    width="24px" alt="Certificado concedido">
                  } @else {
                  <img src="assets/icons/icon_certificado_ausente.svg" matTooltip="Certificado Hub Medical" width="24px"
                    alt="Certificado ausente">
                  }
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Data do Registro:</span>
                <span class="info-separator"></span>
                <span class="info-data">
                  {{ providerPFForm.controls["registerDate"].value | date : "dd/MM/yyyy" }}
                </span>
              </div>

              <div class="info-row">
                <span class="info-label">Status:</span>
                <span class="info-separator"></span>
                <strong class="info-data">
                  {{ providerPFForm.controls["status"].value | enumDescription }}
                </strong>
              </div>
            </div>

            <div class="card-footer">
              <app-certification-button color="warn"
                [subject]="'Solicito certificado para a perfil PF ID:' + providerPFForm.controls['id'].value"
                [itemId]="providerPFForm.controls['id'].value" [certified]="checkAllCertification()">
              </app-certification-button>

              <div class="alert alert-info mt-md">
                <span>ℹ</span>
                <div>
                  <strong>Observação:</strong> Para obter o certificado, todos os itens acima devem estar com o selo
                  concedido.
                </div>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </swiper-slide>

  </swiper-container>
</app-swiper>
}